// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from TableRow.module.scss  */
.TableRow-module-Root_1_I:nth-child(even):hover td, .TableRow-module-Root_1_I:nth-child(odd):hover td {
  background-color: #ecf1ff; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Table/Row/TableRow.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,yBAAyB,EAAE","sourcesContent":["/*  imported from TableRow.module.scss  */\n.TableRow-module-Root_1_I:nth-child(even):hover td, .TableRow-module-Root_1_I:nth-child(odd):hover td {\n  background-color: #ecf1ff; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
